import { InfoIcon } from '@sharedCR/coreDesignSystem/icons';

import { HORIZONTAL_ALIGNMENT } from 'constants/ui';

import { getProgramNameTooltip } from '../../ChooseProgramPopup/ChooseProgramPopup.utils';

const infoButtonWithTooltipProps = {
  icon: InfoIcon,
  size: 'small',
  iconSize: 10,
  className: 'ml-2 p-0',
  spanContainerClassName: 'absolute',
  PopperProps: {
    disablePortal: true,
    popperOptions: { positionFixed: true },
  },
};

export const ColumnIds = {
  ELIGIBILITY: 'eligibility',
  INVESTOR: 'vendorType',
  PROGRAM_NAME: 'internalName',
  RATE: 'rate',
  CREDIT: 'credit',
  PAYMENT: 'paymentMonth',
  LOCK_PERIOD: 'lockTerm',
};

export const defaultSortOrder = {
  id: ColumnIds.PROGRAM_NAME,
};

export const columnsDefs = [
  {
    id: ColumnIds.INVESTOR,
    label: 'Investor',
    style: {
      width: '14.5%',
    },
  },
  {
    id: ColumnIds.PROGRAM_NAME,
    label: 'Program Name',
    style: {
      width: '26.5%',
    },
  },
  {
    id: ColumnIds.RATE,
    label: 'Rate / APR',
    align: HORIZONTAL_ALIGNMENT.RIGHT,
    style: {
      width: '15%',
    },
  },
  {
    id: ColumnIds.CREDIT,
    label: 'Credit or Cost / Comp',
    align: HORIZONTAL_ALIGNMENT.RIGHT,
    style: {
      width: '15.0%',
    },
    getTooltip: getProgramNameTooltip,
    iconButtonProps: infoButtonWithTooltipProps,
  },
  {
    id: ColumnIds.PAYMENT,
    label: 'Payment(+MI)',
    align: HORIZONTAL_ALIGNMENT.RIGHT,
    style: {
      width: '15.0%',
    },
  },
  {
    id: ColumnIds.LOCK_PERIOD,
    label: 'Lock Period',
    align: HORIZONTAL_ALIGNMENT.RIGHT,
    style: {
      width: '14.0%',
    },
  },
];

export const NIL_OR_NAN_DEFAULT_PLACEHOLDER = '-';
